import { render, staticRenderFns } from "./ModalDeleteContent.vue?vue&type=template&id=c44d60dc&"
import script from "./ModalDeleteContent.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteContent.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports